export const PROMO_START_DATE = '2026-06-23T00:00:00+03:00'
export const PROMO_END_DATE = '2026-07-09T23:59:59+03:00'
